import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import useColorFilterSelection from "./UseColorFilterSelection";
import { removeFiltersPayload } from "@redux/slices/searchFilters";

const useRemoveFancyColorFilters = (sectionName: any) => {
  const dispatch = useDispatch();
  const {
    isWhiteColorsSelected,
    isFancyColorsSelected,
    isOvertonesSelected,
    isIntensitiesSelected,
  } = useColorFilterSelection(sectionName);

  const whiteSelected = isWhiteColorsSelected();
  const fancySelected = isFancyColorsSelected();
  const overtonesSelected = isOvertonesSelected();
  const intensitiesSelected = isIntensitiesSelected();

  const prevWhiteSelected = useRef(whiteSelected);

  useEffect(() => {
    if (whiteSelected && !prevWhiteSelected.current) {
      const payloadsToRemove: string[] = [];
      if (fancySelected) payloadsToRemove.push("fancy_colors");
      if (overtonesSelected) payloadsToRemove.push("fancy_color_overtones");
      if (intensitiesSelected) {
        payloadsToRemove.push(
          "fancy_color_intensity_to",
          "fancy_color_intensity_from"
        );
      }

      if (payloadsToRemove.length > 0) {
        dispatch(
          removeFiltersPayload({
            sectionName,
            payloadName: payloadsToRemove,
          })
        );
      }
    }

    prevWhiteSelected.current = whiteSelected;
  }, [
    whiteSelected,
    fancySelected,
    overtonesSelected,
    intensitiesSelected,
    dispatch,
    sectionName,
  ]);
};

export default useRemoveFancyColorFilters;
